"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISSUING_BALANCE_TRANSFER_CRON = exports.ISSUING_PROCESS_REWARD_CRON = exports.ISSUING_MONTHLY_REPORT_CRON = exports.getZeffyRewardAmount = exports.getIssuingMonthlyExportDate = void 0;
const dates_1 = require("./dates");
const ISSUING_EXPORT_DAY_OFFSET = 3; // as report is sent on 1st of the month, we need to offset by 3 days to be sure all transactions of previous month are included
const getIssuingMonthlyExportDate = () => {
    const dateMinusOffset = (0, dates_1.getDateMinusNDays)(new Date(), ISSUING_EXPORT_DAY_OFFSET); // The cron run the 1st of the month
    const [startDate] = (0, dates_1.getMonthBoundaries)(dateMinusOffset.getMonth(), dateMinusOffset.getFullYear());
    const endDate = new Date();
    return [startDate, endDate];
};
exports.getIssuingMonthlyExportDate = getIssuingMonthlyExportDate;
const getZeffyRewardAmount = (amount) => {
    const result = Math.round(amount * 0.0125);
    if (result < 100) {
        return 0;
    }
    return result;
};
exports.getZeffyRewardAmount = getZeffyRewardAmount;
exports.ISSUING_MONTHLY_REPORT_CRON = "0 12 1 * *";
exports.ISSUING_PROCESS_REWARD_CRON = "0 1 10 * *";
exports.ISSUING_BALANCE_TRANSFER_CRON = "0 1 * * *";
